// extracted by mini-css-extract-plugin
module.exports = {"block":"blogTemplate-module--block--2JZZw","carouselImage":"blogTemplate-module--carouselImage--3h9A4","content":"blogTemplate-module--content--Gctq-"};